/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  defaultDirection: 'defaultDirection',
  loading: 'loading',
  removeAll: 'removeAll',
  selectAll: 'selectAll',
  ok: 'ok',
  noResult: 'noResult'
}; export default Keys;